module.exports = __webpack_public_path__ + "img/Pr25.89a22a23.png";